const H2Base = ({text, tailwindClass = ""}) => {
    let finalClass = "mb-6 text-secondary text-3xl font-bold";
    if (typeof tailwindClass === "string") {
        finalClass += " " + tailwindClass;
    }


    return <h2 className={finalClass}>{text}</h2>
}
export default H2Base;